import authAxios from "../utility/authAxios";
import { API_VERSION, SAAS_SERVICE_PATH } from "../config/axios";
import {enableHeaderCache, setHttpParams} from "../utility/utils";

const API_URI = `/${SAAS_SERVICE_PATH}/counter`;

export const getCounters = async (params = {}) => {
    params = setHttpParams(params);
    return authAxios.get(`${API_VERSION}${API_URI}?${params}`);
};
export const get = async (id, cache = false) => {
    if(id){
        return authAxios.get(`${API_VERSION}${API_URI}/${id}`, enableHeaderCache(cache));
    }
};

export const create = async (data) => {
    return authAxios.post(`${API_VERSION}${API_URI}`, data);
};
export const update = async (id, data) => {
    return authAxios.put(`${API_VERSION}${API_URI}/${id}`, data);
};

export const remove = async (id) => {
    return authAxios.delete(`${API_VERSION}${API_URI}/${id}`);
};
